import { AssignmentRules } from "./AssignmentRules";
import { RotationList } from "./RotationList";
import { ShowingRotationProps } from "./types";

export const ShowingRotation = ({
  propertyId,
  showingType
}: ShowingRotationProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-6">
      <div className="w-full md:max-w-[548px] md:shrink-0 h-fit">
        <AssignmentRules />
      </div>
      <div className="flex-1 min-w-0">
        <RotationList propertyId={propertyId} showingType={showingType} />
      </div>
    </div>
  );
};
